import { api } from "../Configurations/axios";

const GetCompany = async (id: string) => {
    try {

        const result = await api.get(`/Companies/GetCompany/${id}`);
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const ShowTenant = async (id: string, alternancy: boolean) => {
    try {
        const result = await api.get(`/TenatsCompanies/Show/?id=${id}&alternancy=${alternancy}`);
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const GetCompanies = async () => {
    try {
        const result = await api.get("/Companies/GetCompanies");
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}
const GetTenants = async (page: number, search: string) => {
    try {
        const result = await api.get(`/TenatsCompanies/GetPagination/?currentPage=${page}&search=${encodeURIComponent(search)}`);
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const UpdateSituationAPI = async (companyId: string, contractType: string, processStep: string, userEmail: string) => {
    try {
        var result = await api.put("/Companies/UpdateSituation", { companyId: companyId, contractType: contractType, processStep: processStep, userEmail: userEmail });
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const UpdateCompanyInfoAPI = async (userEmail: string, companyId: string, cnpj: string, city: string, postalCode: string, address: string, potentialText: string) => {
    try {
        var result = await api.put('/Companies/UpdateCompanyInfo', {
            userEmail: userEmail,
            cnpj: cnpj,
            companyId: companyId,
            city: city,
            postalCode: postalCode,
            address: address,
            potential: potentialText
        });
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const UpdateImageCompanyAPI = async (file: File, companyId: string, userEmail: string) => {
    try {
        var commandForm = new FormData();

        commandForm.append("ImageFile", file);
        commandForm.append("CompanyId", companyId);
        commandForm.append("UserEmail", userEmail);


        var result = await api.put(`/Companies/UpdateImageCompany`, commandForm, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const GetCompanyLogo = async (id: string) => {
    try {
        const result = await api.get(`/Companies/GetCompanyLogo/${id}`, {
            responseType: 'arraybuffer'
        });
        return result;
    } catch (error: any) {
        throw new Error(error.response?.data || "Erro ao buscar logo da empresa");
    }
}

export {
    GetCompany,
    GetCompanies,
    ShowTenant,
    GetTenants,
    UpdateSituationAPI,
    UpdateCompanyInfoAPI,
    UpdateImageCompanyAPI,
    GetCompanyLogo
}